import config from '../config';
import { tickets } from '../lib/tickets';
import apiClient from './apiClient';

class TicketsService {
  static controller = new AbortController();

  static getTickets = async (type) => {
    return await apiClient.post(
      `${config.API_BASE_URL}/landing-general/getByType`,
      {
        type: type ? type : 'OFFER',
      }
    );
  };

  static calculateLandingTicketSelector = async (data) => {
    return await apiClient.post(
      `${config.API_BASE_URL}/orders/landing-selector`,
      data
    );
  };
  // static getTickets = async () => {
  //   return new Promise((res, rej) => {
  //     setTimeout(() => {
  //       res(tickets);
  //     }, 1000);
  //   });
  // };

  static createUnAuthOrder = async (order) => {
    const type = process.env.REACT_APP_TYPE;

    return await apiClient.post(
      `${config.API_BASE_URL}/orders/unAuth/create`,
      {
        ...order,
        isLandingPage: type === 'pagediscount' ? false : true,
        isPageDiscount: type === 'pagediscount' ? true : false,
        orderType: 'OFFER',
      }
    );
  };

  static getCurrentPrizeId = async () => {
    const prizeId = '63737eb1c3e2e50033e5446c';
    return new Promise((res, rej) => {
      setTimeout(() => {
        res(prizeId);
      }, 1000);
    });
  };
  static getActiveRaffles = async () => {
    const response = await apiClient.get(
      `${config.API_BASE_URL}/raffles/active/countdowns`
    );
    return response;
  };
  static getActiveSubscriptionModels = async () => {
    const response = await apiClient.get(
      `${config.API_BASE_URL}/subscription-models/active`
    );
    return response;
  };
  static getActiveRafflesAndSubscriptionModels = async () => {
    let raffleResponse = await this.getActiveRaffles();
    let subscriptionModels = await this.getActiveSubscriptionModels();
    return {
      raffles: raffleResponse.data ?? [],
      subscriptionModels: subscriptionModels.data.subscriptionModels ?? [],
    };
  };
  static generateBasketToken = async (basketData) => {
    return await apiClient.post(
      `${config.API_BASE_URL}/other-orders/create-order`,
      {
        data: basketData,
      }
    );
  };
  static redirectByToken = (token) => {
    const link = document.createElement('a');
    link.href = `${config.APP_BASE_URL}/other-orders?token=${token}`;
    link.click();
    link.remove();
  };
  static redirectByOrderIds = (orderIds) => {
    const link = document.createElement('a');
    link.href = `${config.APP_BASE_URL}/other-orders?orderIds=${orderIds}`;
    link.click();
    link.remove();
  };
  static redirectByOrderWithSubscriptionIds = (orderIds, subscriptionIds) => {
    const link = document.createElement('a');
    link.href = `${config.APP_BASE_URL}/other-orders?orderIds=${orderIds}&subscriptionIds=${subscriptionIds}`;
    link.click();
    link.remove();
  };
  static goToPost = () => {
    if (window != null) {
      window.open(`${config.APP_BASE_URL}/post`);
    }
  };
  static goToSubscribe = (id) => {
    if (window != null) {
      window.open(`${config.APP_BASE_URL}/subscription`);
    }
  };
  static createUnAuthSubscription = async (subscription) => {
    const type = process.env.REACT_APP_TYPE;
    
    return await apiClient.post(
      `${config.API_BASE_URL}/subscriptions/unAuth/create`,
      {
        subscription,
        isLandingPage: type === 'pagediscount' ? false : true,
        isPageDiscount: type === 'pagediscount' ? true : false,
        orderType: 'WIN',
      }
    );
  };
}

export default TicketsService;
